module.exports = __webpack_public_path__ + "img/ZS_logo.9e4ce0f7.svg";